<template>
    <div>
        <h2 v-text="'404 - Pagina non trovata'" class="payoff" :class="$web.isDesktop?'desktop-payoff':'mobile-payoff'"/>
    </div>
</template>

<script>

export default {
    name: 'page_404',
};
</script>

<style lang="scss" scoped>
.payoff {
    font-style: normal;
    font-weight: bold;
    font-size: 30px;
    margin: 3vh 0;
    text-align: center;
    color: #fff;
    line-height: 42px;
    @media screen and (max-width: 460px) {
        font-size: 7vw;
    }
}
.mobile-payoff {
    color: #000;
}
</style>